module.exports = __webpack_public_path__ + "static/media/mitutoyo-logo.c6f1e970.png";